export const SERVICE = 'service_6fdmzuw';
export const TEMPLATE = 'template_fsfqttb';
export const KEY = 'LrziTML8PP_8Of_YA';